module.exports = __webpack_public_path__ + "logo-orkla-tagline-com-98680d1e1538648a6be55c64a97de1b5.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-com.svg
// module id = 60
// module chunks = 0